import type { GridColTypeDef } from '@packages/fenrir/components/datagrid';

export const hiddenColumnType: GridColTypeDef<string> = {
  display: 'flex',
  flex: 0,
  minWidth: 100,
  hideable: false,
  sortable: false,
};
